import { Fragment } from 'react';
import SmartLink from '@/components/SmartLink';
import type { ContentSegment } from '@/content/content';

interface RichTextProps {
  segments: ContentSegment[];
  className?: string;
}

/** Renders a paragraph of content segments: plain strings as text, objects as inline links. */
const RichText = ({ segments, className }: RichTextProps): JSX.Element => (
  <p className={className}>
    {segments.map((segment, index) =>
      typeof segment === 'string' ? (
        <Fragment key={index}>{segment}</Fragment>
      ) : (
        <SmartLink
          key={index}
          to={segment.to}
          className="font-semibold text-primary-ink underline-offset-2 hover:underline dark:text-primary"
        >
          {segment.label}
        </SmartLink>
      ),
    )}
  </p>
);

export default RichText;
